import { observer } from "mobx-react-lite";
import React , { useContext, useEffect, useState, useRef } from "react";
import { Breadcrumb, Button, Col, Container, Form, Placeholder, Row, Table } from "react-bootstrap";

import { Context } from "../index";
import { NavLink, useNavigate, useLocation } from "react-router-dom"
import { INDEX_ROUTE, LOGIN_ROUTE } from "../utils/consts";
import Calendar from "../components/Calendar";
import { fetchSale1, fetchSale2, getCall} from "../http/salesAPI";
import WidthModal from "../components/modals/WidthModal"

const fetchAudioUrl = async (recordId) => {
  const token = 'c47db09d-e1ca-4680-94bb-c3519d0920d4';
  const response = await fetch(
    `https://cloudpbx.beeline.ru/apis/portal/records/${recordId}/reference?recordId=${recordId}`,
    {
      method: 'GET',
      headers: {
        'X-MPBX-API-AUTH-TOKEN': token,
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Ошибка: ${response.status}`);
  }

  const data = await response.json();
  return data.url;
};



const API_BASE_URL = 'https://olap.ak-i.ru'; // Замените на ваш реальный базовый URL, если отличается

function AudioPlayer({ recordId }) {
  const [audioSrc, setAudioSrc] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (!recordId) return;
    setLoading(true);
    // Формируем URL к вашему прокси. 
    // Убедитесь, что путь совпадает с роутом на сервере!
    const proxyUrl = `${API_BASE_URL}/api/up/getCall?id=${recordId}`; 
    setAudioSrc(proxyUrl);
    setLoading(false);
  };

  return (
    <div>
      {!audioSrc && (
        <button className="btn btn-warning" onClick={handleClick} disabled={loading}>
          {loading ? 'Загрузка...' : 'Воспроизвести запись'}
        </button>
      )}

      {audioSrc && (
        <audio 
          controls 
          src={audioSrc}
          type="audio/mpeg"  // <--- ДОБАВЬТЕ ЭТО. Это критично для Safari
          preload="metadata"
          onError={(e) => {
            // Подробная отладка
            console.error('Audio Error Code:', e.target.error?.code);
            console.error('Current Src:', e.target.currentSrc);
            
            // Попробуем сделать fetch вручную, чтобы увидеть ответ сервера
            fetch(audioSrc)
              .then(r => {
                 console.log('Fetch Status:', r.status);
                 console.log('Content-Type Header:', r.headers.get('content-type'));
                 return r.text(); // Читаем тело, если это ошибка HTML
              })
              .then(text => console.log('Response Body Preview:', text.substring(0, 200)))
              .catch(err => console.error('Fetch debug error:', err));
          }}
        >
          Ваш браузер не поддерживает аудио.
        </audio>
      )}
    </div>
  );
}

const Sale2 = observer(() => {

    const location = useLocation()

    let s_d=''
    let e_d=''
    try {
        if (location.search.split('?')[1].split('&')[0].split('=')[0]==='startdate'){
            s_d=location.search.split('?')[1].split('&')[0].split('=')[1]
        }
        if (location.search.split('?')[1].split('&')[1].split('=')[0]==='enddate'){
            e_d=location.search.split('?')[1].split('&')[1].split('=')[1]
        }
    } catch (error) {
        //console.error(error)
    }
    
    const click = async () =>{

    //    if (!/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email)) { 
    //        // alert("Не валидный EMAIL!")
    //        setToast({show:true, header:"Ошибка!!!", body:"Невалидный EMAIL!"})
    //        return false
    //     }

       try {
           setTrigger(!trigger)
           setLoading(true)
       } catch (error) {
        //    setToast({show:true, header:"Ошибка!!!", body:error.response.data.message})
            console.error(error)
       }
      
       
   }

    const {user} = useContext(Context)
    const navigate = useNavigate()

    const { sales } = useContext(Context);

    const [modal, setModal] = useState({show:false, header:'', body:''});
  

    let date = new Date()
   // http://localhost:3000/sale1?startdate=2022-08-12&enddate=2022-08-12
    if (s_d==='' || e_d===''){
        // if (date.getDate()===1){
            // s_d=date.getFullYear()+'-'+(('0' + date.getMonth()).slice(-2))+'-'+(('0' + (date.getDate()-1)).slice(-2))
        s_d=date.getFullYear()+'-'+(('0' + (date.getMonth()+1)).slice(-2))+'-'+(('0' + date.getDate()).slice(-2))
        // } else{
            // s_d=date.getFullYear()+'-'+(('0' + (date.getMonth()+1)).slice(-2))+'-'+(('0' + (date.getDate()-1)).slice(-2))
        // }
        
        e_d=date.getFullYear()+'-'+(('0' + (date.getMonth()+1)).slice(-2))+'-'+(('0' + date.getDate()).slice(-2))
    } else {

    }

    const [startDate, setStartDate] = useState(s_d)
    const [endDate, setEndDate] = useState(e_d)
    
    const [loading, setLoading] = useState(true)
    const [trigger, setTrigger] = useState(true)

     const [podrob, setPodrob] = useState('')

    useEffect(() => {
        location.search="?startdate="+startDate+"=&enddate="+endDate
        navigate(location)
        fetchSale2(startDate,endDate).then((data) => {
            console.log(data)
            if(data.succsess){
                sales.setSale1(Object.keys(data).map(function(_) { return data[_]; }));
            } else {
                sales.setSale1(data.error);
            }
           
            
            // console.log(Object.keys(data).map(function(_) { return data[_]; }))
            

            // console.warn( location.search)
            setLoading(false)
        });
        }, [trigger]);

    return ( 
        <>
        <Container className="pt-2" style={{marginBottom:"70px"}}>
        <Breadcrumb>
        <NavLink className="breadcrumb-item" to={INDEX_ROUTE}>Главная</NavLink>
        {/* <Breadcrumb.Item href={SALE1_ROUTE}>
          Library
        </Breadcrumb.Item> */}
        
        <Breadcrumb.Item active>Отчет «Привлечение партнеров IT»</Breadcrumb.Item>
      </Breadcrumb>
             {user.isAuth?
             <>
                <Row>
                    <Col md={12}>
                    <Form className="row">
                    <Form.Group as={Col} xs="6" md="4" className="mt-3" controlId="startDate">
                    <Form.Label>Начальная дата:</Form.Label>
                    <Form.Control
                        // placeholder="Введите ваш email..."
                        value={startDate}
                        onChange={e => setStartDate(e.target.value)}
                        type="date"
                        name="startDate"
                        disabled={loading}
                        // id="startDate"
                        // aria-describedby="loginHelp"
                    />    
                    </Form.Group>
                    <Form.Group as={Col} xs="6" md="4" className="mt-3" controlId="endDate">
                    <Form.Label>Конечная дата:</Form.Label>
                    <Form.Control
                        // placeholder="Дата заверще"
                        value={endDate}
                        onChange={e => setEndDate(e.target.value)}
                        type="date"
                        name="endDate"
                        disabled={loading}
                        // id="endDate"
                        // aria-describedby="loginHelp"
                    />    
                    </Form.Group>
                    <Form.Group as={Col} xs="12" md="4" className="text-center mt-5 " controlId="get">
                    <Button  onClick={click} disabled={loading} variant="success" className="">Посчитать</Button>
                    </Form.Group>
                    </Form>
                        <hr/>
                        <div style={{overflow:"auto", maxHeight:"500px"}}>
                        <Table style={{fontSize:"1rem"}} variant={(sales.sale1[0]!==undefined && sales.sale1[0].rows!==undefined)?"light":"danger"} responsive="md" striped bordered hover>
                            {
                                (sales.sale1[0]!==undefined && sales.sale1[0].rows!==undefined)?
                                <>
                                    <thead>
                                        <tr className="table-dark">
                                            <th rowSpan="2" title="Менеджер" className="text-center">Менеджер</th>
                                            <th colSpan={  Object.values(sales.sale1[0]).length-3 } title="Новые лиды" className="text-center">Воронки</th>
                                            <th  colSpan="2" title="Входящие" className="text-center">Звонки</th>
                                        </tr>
                                        <tr className="table-dark">
                                            {!loading?
                                                Object.values(sales.sale1[0]).filter((item) => ( item.sort!=undefined)).sort((a, b) => a.sort - b.sort).map((item,index) => (
                                                    <th style={{writingMode: 'sideways-lr'}} key={"tfth"+index} className="text-center">{item.name}</th>
                                                ))
                                                :   
                                                <>
                                                    <th colSpan={  Object.values(sales.sale1[0]).length-3 } className="text-center">
                                                        <Placeholder  animation="glow">
                                                            <Placeholder xs={2} />
                                                        </Placeholder>
                                                    </th>  
                                                
                                                </>    
                                            }    
                                            <th style={{writingMode: 'sideways-lr'}} title="Входящие" className="text-center">Входящие</th>
                                            <th style={{writingMode: 'sideways-lr'}} title="Исходящие" className="text-center">Исходящие</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(sales.sale1[0].rows).map(([index2, item2]) => (
                                            
                                            <>
                                            {(!loading && ( user.user.role==='ADMIN'|| (user.user.role==='RUK+' &&
                                            (
                                             (user.user.email =='mazmanov@aktivkredit.ru' && item2.zvonki.group=='335443') ||
                                             (user.user.email =='vlasova@aktivkredit.ru' && item2.zvonki.group=='452082') ||
                                             (user.user.email =='malukhina@aktivkredit.ru' && item2.zvonki.group=='473294') 
                                            )
                                            )))?
                                                <tr
                                                    key={"dr2"+index2}
                                                >
                                                    {!loading?
                                                        <>
                                                            <th className="text-center">{item2.name}   </th>
                                                            {Object.entries(sales.sale1[0]).filter(([index, item]) => ( item.sort!=undefined)).sort(([a, aa],[b,bb]) => aa.sort - bb.sort).map(([index, item]) => (
                                                                <td  
                                                                    style={{cursor:'pointer', '--bs-table-accent-bg':  podrob==(index2+'_'+index)  ? 'silver' : ''}}
                                                                    key={"tbth"+index}
                                                                    className="text-center"
                                                                    onClick={() => setPodrob(index2+'_'+index)}
                                                                >
                                                                    {
                                                                        item2[index].value
                                                                    } 
                                                                </td>
                                    
                                                            ))}
                                                            <td 
                                                                className="text-center"
                                                                onClick={() => setPodrob(index2+'_INBOUND')}
                                                                style={{cursor:'pointer', '--bs-table-accent-bg':  podrob==(index2+'_INBOUND')  ? 'silver' : ''}}
                                                            >  
                                                                {item2.zvonki.vh}
                                                            </td>
                                                            <td 
                                                                className="text-center"
                                                                onClick={() => setPodrob(index2+'_OUTBOUND')}
                                                                style={{cursor:'pointer', '--bs-table-accent-bg':  podrob==(index2+'_OUTBOUND')  ? 'silver' : ''}}
                                                            >  
                                                                {item2.zvonki.ish}
                                                            </td>
                                                        </>    
                                                        :   
                                                        <>
                                                            <th className="text-center">
                                                                <Placeholder  animation="glow">
                                                                    <Placeholder xs={2} />
                                                                </Placeholder>
                                                            </th>
                                                            <th colSpan={  Object.values(sales.sale1[0]).length-3 } className="text-center">
                                                                <Placeholder  animation="glow">
                                                                    <Placeholder xs={2} />
                                                                </Placeholder>
                                                            </th>   
                                                            <th className="text-center">
                                                                <Placeholder  animation="glow">
                                                                    <Placeholder xs={2} />
                                                                </Placeholder>
                                                            </th>   
                                                            <th className="text-center">
                                                                <Placeholder  animation="glow">
                                                                    <Placeholder xs={2} />
                                                                </Placeholder>
                                                            </th>    
                                                        </>    
                                                    }                          
                                                </tr> :''}
                                                {!loading?
                                                Object.entries(sales.sale1[0]).filter(([index, item]) => ( item.sort!=undefined)).sort(([a, aa],[b,bb]) => aa.sort - bb.sort).map(([index, item]) => (
                                                Object.entries(item2[index].entitys).map(([index3, item3]) => (
                                                podrob==index2+'_'+index && 
                                                <tr  >
                                                    <th style={{'--bs-table-accent-bg': 'silver'}} className="text-center">{item2.name}</th>
                                                    <td style={{'--bs-table-accent-bg': 'silver'}} colSpan='2'> <a href={"https://fortunaperm.amocrm.ru/leads/detail/"+item3.entity_id} target="_blank">{item3.entity_id}</a></td>
                                                    <td style={{'--bs-table-accent-bg': 'silver'}} colSpan='4'>{Object.values(item2[index].leads).filter((item4) => ( item4.id==item3.entity_id))[0].name}</td>
                                                    <td style={{'--bs-table-accent-bg': 'silver'}} colSpan={  Object.values(sales.sale1[0]).length-10 }>
                                                        { item3.type == 'lead_added' && 'Создан'} 
                                                        {item3.type === 'lead_status_changed' && (
                                                            <span>
                                                            <b>{sales.sale1[0][item3.value_before[0].lead_status.id].name}</b> »{' '}
                                                            <b style={{color:'green'}}>{sales.sale1[0][item3.value_after[0].lead_status.id].name}</b>
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td style={{'--bs-table-accent-bg': 'silver'}} colSpan='3'>{ Object.values(item2[index].leads).filter((item4) => ( item4.id==item3.entity_id))[0].closest_task_at && new Date(Object.values(item2[index].leads).filter((item4) => ( item4.id==item3.entity_id))[0].closest_task_at * 1000).toLocaleString('ru-RU', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    
                                                    })}</td>       
                                                </tr>   
                                                ))   
                                                )) :''
                                                }

                                                {!loading? Object.entries(item2.zvonki.data).map(([index3, item3]) => (
                                                podrob==index2+'_'+item3.direction && item3.duration>10000 && 
                                                <tr  >
                                                    <th style={{'--bs-table-accent-bg': 'silver'}} className="text-center">{item2.name}</th>
                                                    <td style={{'--bs-table-accent-bg': 'silver'}} colSpan='2'> 
                                                        {item3.direction=='OUTBOUND' && 'Исходящий'}
                                                        {item3.direction=='INBOUND' && 'Входящий'}
                                                    
                                                    </td>
                                                    <td style={{'--bs-table-accent-bg': 'silver'}} colSpan='4'>{item3.phone}</td>
                                                    <td style={{'--bs-table-accent-bg': 'silver'}} colSpan={  Object.values(sales.sale1[0]).length-10 }>
                                                    {Math.round(item3.duration/(10))/100 } сек.
                                                    </td>
                                                    <td style={{'--bs-table-accent-bg': 'silver'}} colSpan='3'> <AudioPlayer recordId={item3.id} /></td>       
                                                </tr>   
                                                )) :''  
                                                }
                                            </>
                                        ))} 
                                 </tbody>

                         {/* <tbody>
                              {sales.sale1.map((item,index) => (
                                 Object.values(item.rows).map((item2,index2) => (
                                 <tr
                                     key={"dr2"+index2}
                                 >
                                    {!loading?
                                        <>
                                            <td className="text-center">{item2.name}</td>
                                            <td className="text-center">{item2.Новый.count}</td>   
                                            <td className="text-center">{item2.Документы.count}</td>   
                                            <td className="text-center">{item2.Заключен.count}</td>   
                                            <td className="text-center">{item2.Выдан.count}</td>   
                                            <td className="text-center">{item2.Отказ.count}</td>   
                                            <td className="text-center">{item2.zvonki.vh}</td>
                                            <td className="text-center">{item2.zvonki.ish}</td>
                                        </>  
                                        :   
                                        <>
                                            <td className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </td>
                                            <td className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </td>   
                                            <td className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </td>   
                                            <td className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </td>   
                                            <td className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </td>   
                                            <td className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </td>   
                                            <td className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </td>   
                                            <td className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </td>   
                                        </>    
                                    }                            
                                 </tr> 
                                  ))
                                 ))} 
                         </tbody>
                         <tfoot>
                              {sales.sale1.map((item,index) => (
                                 <tr
                                    className="table-dark"
                                     key={"dr"+index}
                                 >
                                    {!loading?
                                        <>
                                            <th style={{color:'red'}} className="text-center">Итого:</th>
                                            <th style={{color:'red'}} className="text-center">{item.Новый}</th>
                                            <th style={{color:'red'}} className="text-center">{item.Документы}</th>
                                            <th style={{color:'red'}} className="text-center">{item.Заключен}</th>
                                            <th style={{color:'red'}} className="text-center">{item.Выдан}</th>
                                            <th style={{color:'red'}} className="text-center">{item.Отказ}</th>
                                            <th style={{color:'red'}} className="text-center">{item.vh}</th>
                                            <th style={{color:'red'}} className="text-center">{item.ish}</th>
                                            

                                        </>
                                        :
                                        <>
                                            <th style={{color:'red'}} className="text-center">Итого:</th>
                                            <th style={{color:'red'}} className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </th>
                                            <th style={{color:'red'}} className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </th>
                                            <th style={{color:'red'}} className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </th>
                                            <th style={{color:'red'}} className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </th>
                                            <th style={{color:'red'}} className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </th>
                                            <th style={{color:'red'}} className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </th>
                                            <th style={{color:'red'}} className="text-center">
                                                <Placeholder  animation="glow">
                                                    <Placeholder xs={2} />
                                                </Placeholder>
                                            </th>
                                        </>
                                    }
                                 </tr> 
                                 ))} 
                         </tfoot> */}
                         </>:
                          <thead>
                          <tr>
                              <th>{sales.sale1}</th>
                              
                          </tr>
                      </thead>
                            }
                            
                            
                        </Table>
                        
                        
                        </div>
                    </Col>
                    {/* <Col md={4}>
                        <Calendar/>
                    </Col> */}
                    
                </Row>
                <Row>
                    
                </Row>
                <Row>  
                </Row>
                <Row>
                </Row>
                <WidthModal show={modal.show} onHide={() => setModal({show:false})} header={modal.header} body={modal.body}/>
            </>:
           navigate(LOGIN_ROUTE)
            }
        </Container>
        </>
        // <></>
    // }
    );
});


export default Sale2;